import { Link } from 'react-router-dom'

import { Button, EnumButtonVariants, IButtonProps } from '@insquad/tools'

export const ButtonLink = (props: Omit<IButtonProps<typeof Link>, 'as'>) => {
  return <Button as={Link} {...props} />
}

ButtonLink.Variant = EnumButtonVariants
